/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */

/**
 * ----------------------------------------------------------------------------
 * Search results page.
 * ----------------------------------------------------------------------------
 */
(function(algolia) {
  'use strict';
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = algolia.externals.widgets.hits;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var connectCurrentRefinements = algolia.externals.connectors.connectCurrentRefinements;
  var aa = algolia.externals.aa;

  var themeSettings = window.algoliaInstantSearchThemeSettings || {};

  // Make sure we should be running instant search here.
  if (!algolia.full_results || !algolia.config.instant_search_enabled) {
    return;
  }

  // Until we can get IE11 working, fall back to standard search.
  if (algolia.is_ie11) {
    return;
  }

  var searchFilters = [];
  var activeSortOrders = algolia.sortOrders;
  var results_selector = algolia.config.results_selector;
  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function(routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function(acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  // ==========================================================================
  // CONFIGURATION
  // ==========================================================================

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden: algolia.hiddenFacets,
      shown: algolia.shownFacets,
      list: algolia.facets,
      widgets: algolia.facetsWidgets,
    },
    hitsPerPage: algolia.config.products_full_results_hits_per_page,
    poweredBy: false,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      indexName: algolia.config.index_prefix + 'products',
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
      },
      searchFunction: function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        searchFunctionHelper.setQueryParameter(
          'highlightPreTag',
          '<span class="ais-highlight">'
        );
        searchFunctionHelper.setQueryParameter('highlightPostTag', '</span>');
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        var filters = searchFilters.length ? searchFilters.slice() : [];

        // Override filters.
        searchFunctionHelper.setQueryParameter('filters', filters.join(' AND '));

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders,
    storeName: algolia.storeName,
    templates: {
      currentItem: algolia.getTemplate('instant_search_current_refined_values_item'),
      empty: algolia.getTemplate('instant_search_no_result'),
      page: algolia.compileTemplate('instant_search'),
      product: algolia.getTemplate('instant_search_product'),
      stats: algolia.getTemplate('instant_search_stats'),
      style: algolia.compileTemplate('instant_search.css'),
    },
  };

  algolia.instantsearch = instant;

  // Bind helpers
  var helpers = algolia.assign({}, algolia.helpers, algolia.translation_helpers);
  Object.keys(helpers).forEach(function(name) {
    var helper = helpers[name];
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  algolia.appendStyle(
    algolia.render(instant.templates.style, {
      distinct: instant.distinct,
      colors: instant.colors,
    })
  );

  var resultsElement = document.querySelectorAll(results_selector)[0];

  if (!resultsElement) {
    throw new Error(
      'Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  }

  instant.$results = resultsElement;

  instant.$results.innerHTML = algolia.render(instant.templates.page, {
    facets: instant.facets.list,
    storeName: instant.storeName,
    translations: algolia.translations,
    multipleSortOrders: activeSortOrders.length > 1
  });

  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      clickAnalytics: true,
      facetingAfterDistinct: Boolean(algolia.config.show_products),
      maxValuesPerFacet: 30
    }),
  ]);

  // ==========================================================================
  // UI WIDGETS
  // ==========================================================================

  function analyticsEvent(query) {
    document.dispatchEvent(
      new CustomEvent('theme.algoliaSearch', {
        detail: {
          searchQuery: query,
          searchPageType: 'search'
        }
      })
    );
  }

  var searchAsYouType = false;
  var debounceTimer;
  var debounceTimeout = 500;

  // Search input
  instant.search.addWidgets([
    searchBox({
      container: '.ais-search-box-container',
      autofocus: false,
      showReset: true,
      showSubmit: true,
      showLoadingIndicator: false,
      searchAsYouType: searchAsYouType,
      placeholder: 'Search keywords or part numbers...',
      cssClasses: {
        form: 'algolia-search-form',
        input: 'algolia-search-form__input form__field form__field--text',
        submit: 'algolia-search-form__submit button button--secondary',
        reset: 'algolia-search-form__reset button',
        submitIcon: 'icon'
      },
      queryHook: function(query, search) {
        analyticsEvent(query);
        if (searchAsYouType) {
          return search(query);
        }
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          search(query);
        }, debounceTimeout);
      }
    }),
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text: instant.templates.stats,
      },
    }),
  ]);

  // Stats (mobile)
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-mobile-container',
      templates: {
        text: instant.templates.stats,
      },
    }),
  ]);

  // Sort orders
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container',
        items: instant.sortOrders,
        cssClasses: {
          root: 'algolia-sort-by',
          select: 'algolia-sort-by__select',
        }
      }),
    ]);
  }

  // ==========================================================================
  // FACETS
  // ==========================================================================

  // Hidden facets
  var list = instant.facets.hidden.map(function(facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function() {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function() {},
    },
  ]);

  // Create the render function
  var createDataAttributes = function(refinement) {
    return Object.keys(refinement)
      .map(function(key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItem = function(item) {
    var facet = instant.facets.list.find(function(f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function(refinement) {
        return (
          '<div class="collection__active-filter-item">' +
          '  <button ' + createDataAttributes(refinement) + 'class="collection__active-filter-cross ais-current-refined-values--link">' +
          '    <svg focusable="false" class="icon icon--close" viewBox="0 0 19 19" role="presentation">' +
          '      <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>' +
          '    </svg>' +
          '  </button>' +
            refinement.label +
          '</div>'
        );
      })
      .join('');
  };

  var renderCurrentRefinements = function(renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    widgetParams.container.innerHTML =
      '<div class="ais-root ais-current-refined-values ais-facet">' +
      '  <div class="collection__active-filters">' +
          items.map(renderListItem).join('') +
      '  </div>' +
      '</div>';

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          '.ais-current-refined-values--link'
        )
      )
      .forEach(function(element) {
        element.addEventListener('click', function(event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function(
            acc,
            key
          ) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);;
            return algolia.assign({}, acc, itemData);
          },
          {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );

  var hasRefinements = function(helper, facetsList) {
    return facetsList.some(function(f) {
      var isConjunctiveFacetRefined =
        helper.state.isConjunctiveFacet(f.name) &&
        helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined =
        helper.state.isDisjunctiveFacet(f.name) &&
        helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined =
        helper.state.isHierarchicalFacet(f.name) &&
        helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function(
        operator
      ) {
        return numericRefinements[operator].length > 0;
      });

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  /**
   * Decides whether the given `facetName` has any facet values available in
   * the current result set by checking the available `facets`,
   * `disjunctiveFacets` and `hierarchicalFacets`.
   */
  var hasFacetValues = function(resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function(facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );

    return (
      isFacetValueAvailable ||
      isDisjunctiveFacetValueAvailable ||
      isHierarchicalFacetValueAvailable
    );
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  var renderMobileRefinementsToggle = function(renderOptions) {
    var items = renderOptions.items;
    var widgetParams = renderOptions.widgetParams;

    var itemCount = 0;
    items.forEach(function(item) {
      itemCount += item.refinements.length;
    });

    var filterIcon =
      '<svg focusable="false" class="icon icon--filter" viewBox="0 0 19 20" role="presentation">' +
      '  <path d="M17.0288086 4.01391602L11 9v7.0072021l-4 2.008545V9L1.01306152 4.01391602V1H17.0288086z" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="square"></path>' +
      '</svg>';

    widgetParams.container.innerHTML =
      '<button class="collection__toolbar-item collection__toolbar-item--filter hidden-lap-and-up" data-action="open-drawer" aria-haspopup="true" aria-expanded="false" aria-controls="mobile-collection-filters">' +
      '  <span class="collection__filter-icon ' + (itemCount > 0 ? 'collection__filter-icon--active' : '') + '">' + filterIcon + '</span>' +
      '  Filters ' + (itemCount > 0 ? '(' + itemCount + ')' : '') +
      '</button>';
  };

  var mobileRefinementsToggle = connectCurrentRefinements(
    renderMobileRefinementsToggle
  );

  instant.search.addWidgets([
    mobileRefinementsToggle({
      container: document.querySelector('.ais-mobile-refinements-toggle')
    }),
  ]);

  /**
   * Setup the facets for search.
   * We are using a `panel` with a custom `hidden` function which will allow
   * us to hide the parent container of the facet if there are no facet values
   * available for that particular facet.
   */
  instant.facets.widgets.forEach(function(widget) {
    function addWidget(prefix) {
      var facetWithPanel = panel({
        hidden: function(options) {
          var hide = !hasFacetValues(options.results, widget.params.attribute);
          var displayStyle = hide ? 'none' : '';
          var classPrefix = prefix ? '-' + prefix : '';
          /**
           * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
           * can work as expected. "." is supposed to be present for named tags
           * and metafield based facet names and "%" is present when the facet name has a space
           * in it because of the encoding.
           */
          var parentContainerClassName = '.ais' + classPrefix + '-facet-' + encodeURIComponent(
            widget.params.attribute
            ).replace(/\./g, '\\.').replace(/\%/g, '\\%');
          var parentContainer = document.querySelector(parentContainerClassName);


          if (parentContainer) {
            parentContainer.style.display = displayStyle;
          }

          return hide;
        },
      })(widget.widget);

      instant.search.addWidgets([facetWithPanel(widget.params)]);
    }
    addWidget('');
    addWidget('mobile');
  });

  // ==========================================================================
  // RESULTS
  // ==========================================================================

  // TODO: Support different quick buy / quick view modes here.
  var additionalListClasses = themeSettings.quickView && themeSettings.quickView !== 'disabled'
    ? 'product-list--with-quick-view'
    : 'product-list--no-quick-view';

  // Hits
  // https://www.algolia.com/doc/api-reference/widgets/hits/js/
  instant.search.addWidgets([
    hits({
      container: '.ais-hits-container',
      templates: {
        empty: instant.templates.empty,
        item: instant.templates.product,
      },
      cssClasses: {
        list: ['product-list', 'product-list--collection', 'product-list--with-sidebar', additionalListClasses],
        item: ['product-item', 'product-item--vertical', '1/3--tablet-and-up 1/4--desk'],
      },
      transformItems: function(products) {
        return products.map(function(product) {
          return algolia.assign({}, product, {
            _distinct: instant.distinct,
            can_order:
              product.inventory_management !== 'shopify' ||
              product.inventory_policy === 'continue' ||
              product.inventory_quantity > 0,
            translations: algolia.translations,
            queryID: product.__queryID,
            productPosition: product.__position,
            index: instant.search.mainIndex.getIndexName(),
          });
        });
      },
    }),
  ]);

  // Redirect to product on click
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var hit;
          do {
            if (el.matches('.ais-hit')) {
              hit = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!hit) {
            return;
          }
          var $this = hit;
          var productHandle = $this.dataset.handle;
          var variant_id = $this.dataset.variantId;
          var distinct = $this.dataset.distinct;

          // Construct the link we should redirect to
          var link = '';

          // If we're on a collection page and the handle is available
          // then prefix the product link with the collection handle
          // if (collectionPageEnabled && collectionHandle) {
          //   link = '/collections/' + collectionHandle;
          // }

          // Add the product handle to the link
          link = link + '/products/' + productHandle;

          // Add the variant ID details to redirect to a specific
          // variant ID if we are showing variants and not products
          if (distinct !== 'true') {
            link += '?variant=' + variant_id;
          }

          if (algolia.config.analytics_enabled) {
            var clickData = {
              index: hit.dataset.algoliaIndex,
              eventName: 'click',
              queryID: hit.dataset.algoliaQueryid,
              objectIDs: [hit.dataset.algoliaObjectid],
              positions: [Number(hit.dataset.algoliaPosition)],
            };

            // Send the click event
            aa.clickedObjectIDsAfterSearch(clickData);
            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
            // algolia.saveForConversionTracking(clickData);
          }
          window.location.href = link;
        });
      },
    },
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function(opts) {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function(facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);

  // Pagination
  // https://www.algolia.com/doc/api-reference/widgets/pagination/js/
  instant.search.addWidgets([
    pagination({
      container: '.ais-pagination-container',
      padding: 3,
      maxPages: 20,
      showFirst: false,
      showLast: false,
      cssClasses: {
        root: 'pagination__inner',
        list: 'pagination__nav',
        pageItem: 'pagination__nav-item',
        'previousPageItem': ['pagination__prev', 'link'],
        'nextPageItem': ['pagination__next', 'link'],
        'firstPageItem': ['pagination__prev', 'link'],
        'lastPageItem': ['pagination__next', 'link'],
        'selectedItem': 'is-active',
      },
      templates: {
        previous: "« Previous",
        next: "Next »",
      },
    }),
  ]);

  // ==========================================================================
  // RUN
  // ==========================================================================

  instant.search.start();

  /**
  * Render callback to set appropriate hit classes based on active layout mode.
  *
  * We use the theme's layout switcher instead of Algolia's. Each render will wipe
  * out the active classes, so we re-add them here based on selected layout.
  */
  instant.search.on('render', function() {
    var button = document.querySelector('.ais-layout-switcher .collection__layout-button.is-selected');
    var mode = button ? button.dataset.layoutMode : null;

    if (!button || !mode) return;

    var items = document.querySelectorAll('.ais-hits-container .product-list .product-item') || [];
    items.forEach(function(item) {
      if (mode === 'list') {
        item.className = 'product-item product-item--list';
      }
      else {
        item.className = 'product-item product-item--vertical 1/3--tablet-and-up 1/4--desk'
      }
    });
  });

  // Unhide container.
  if (algolia.contentHide) {
    algolia.contentHide.parentNode.removeChild(algolia.contentHide);
  }

})(window.algoliaShopify);



/**
 * ----------------------------------------------------------------------------
 * Collection pages
 * ----------------------------------------------------------------------------
 *
 * All this initialization code has been broken out for collection pages
 * because it ended up being very different. It would be good to merge
 * everything back in a clean way.
 */
(function(algolia) {
  'use strict';
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var hits = algolia.externals.widgets.hits;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var aa = algolia.externals.aa;

  var themeSettings = window.algoliaInstantSearchThemeSettings || {};

  // Make sure we should be running instant search here.
  if (!algolia.is_collection_results_page || !algolia.config.instant_search_enabled_on_collection || !themeSettings.collectionSearchEnabled) {
    return;
  }

  // Until we can get IE11 working, no collection search.
  if (algolia.is_ie11) {
    return;
  }

  var searchFilters = [];
  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  var collectionHandle = null;
  var collectionSearchStarted = false;
  var isPartsCollection = themeSettings.collectionTemplate === 'parts';
  var partsFields = themeSettings.partsFields;
  var partsSkuLabel = themeSettings.partsSkuLabel;

  var unavailableTags = ['requires-quote', 'out-of-stock', 'discontinued'];

  /**
   * Extracts current collection tag values from the page.
   *
   * We store tags on a hidden DOM element within the standard collection results container.
   * This is necessary because the theme updates the collection page via AJAX when filters are clicked.
   */
  var collectionTagsFromPage = function() {
    var tagsElement = document.getElementById('ais-collection-tags');
    return tagsElement && tagsElement.dataset.tags ? JSON.parse(tagsElement.dataset.tags) : [];
  }

  var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
  collectionHandle = Boolean(matches) && matches.length === 2 ? matches[1] : null;

  if (algolia.config.collection_id_indexing) {
    collectionFacetFilter = algolia.current_collection_id ? 'collection_ids:"' + algolia.current_collection_id + '"' : null;
  }
  else {
    collectionFacetFilter = 'collections:"' + collectionHandle + '"';
  }

  // Add the collection filter to the list of search filters
  searchFilters.push(collectionFacetFilter);

  collectionRulesContextValue = algolia.config.collection_id_query_rules ? algolia.current_collection_id : collectionHandle;

  var activeSortOrders = algolia.collectionSortOrders || algolia.sortOrders;
  var results_selector = algolia.config.collection_css_selector;
  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function(routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function(acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: isPartsCollection ? false : Boolean(algolia.config.show_products),
    facets: {
      hidden: algolia.collectionHiddenFacets || algolia.hiddenFacets,
      shown:algolia.collectionShownFacets || algolia.shownFacets,
      list: algolia.collectionFacets || algolia.facets,
      widgets: algolia.collectionFacetsWidgets || algolia.facetsWidgets,
    },
    hitsPerPage: isPartsCollection ? 50 : (algolia.config.collections_full_results_hits_per_page || algolia.config.products_full_results_hits_per_page),
    poweredBy: false,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      indexName: algolia.config.index_prefix + 'products',
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
      },
      searchFunction: function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        searchFunctionHelper.setQueryParameter(
          'highlightPreTag',
          '<span class="ais-highlight">'
        );
        searchFunctionHelper.setQueryParameter('highlightPostTag', '</span>');
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        var filters = searchFilters.length ? searchFilters.slice() : [];

        var tags = collectionTagsFromPage();
        if (tags.length > 0) {
          tags.forEach(function(tag) {
            filters.push('tags:"' + tag.replace(/"/g, '\\"') + '"');
          })
        }

        // Override filters.
        searchFunctionHelper.setQueryParameter('filters', filters.join(' AND '));

        // Collection page merchandising:
        // If we are on a collection page, `collectionRulesContextValue` is defined
        searchFunctionHelper.setQueryParameter('ruleContexts',
          collectionRulesContextValue ? [collectionRulesContextValue.toString()] : [],
        );

        if (!collectionSearchStarted) {
          // Prevent Algolia from making a search request unless we have a query. However, once a query
          // has been submitted, we always let the request through, otherwise we mess up the app state.
          if (searchFunctionHelper.state.query && searchFunctionHelper.state.query.length > 0) {
            collectionSearchStarted = true;
            searchFunctionHelper.setPage(page);
            searchFunctionHelper.search();
          }
        }
        else {
          searchFunctionHelper.setPage(page);
          searchFunctionHelper.search();
        }
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders,
    storeName: algolia.storeName,
    templates: {
      currentItem: algolia.getTemplate('instant_search_current_refined_values_item'),
      empty: algolia.getTemplate('instant_search_no_result'),
      page: algolia.compileTemplate('instant_search_collection'),
      parts: algolia.compileTemplate('instant_search_parts'),
      product: algolia.getTemplate('instant_search_product'),
      stats: algolia.getTemplate('instant_search_stats'),
      style: algolia.compileTemplate('instant_search.css'),
    },
  };

  algolia.instantsearch = instant;

  // Bind helpers
  var helpers = algolia.assign({}, algolia.helpers, algolia.translation_helpers);
  Object.keys(helpers).forEach(function(name) {
    var helper = helpers[name];
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  algolia.appendStyle(
    algolia.render(instant.templates.style, {
      distinct: instant.distinct,
      colors: instant.colors,
    })
  );

  var resultsElement = document.querySelectorAll(results_selector)[0];

  if (!resultsElement) {
    throw new Error(
      'Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector'
    );
  }

  instant.$results = resultsElement;

  instant.$results.innerHTML = algolia.render(instant.templates.page, {
    facets: instant.facets.list,
    storeName: instant.storeName,
    translations: algolia.translations,
    multipleSortOrders: activeSortOrders.length > 1,
    hideToolbar: isPartsCollection ? true : false,
  });

  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      clickAnalytics: true,
      facetingAfterDistinct: Boolean(algolia.config.show_products),
      maxValuesPerFacet: 30
    }),
  ]);

  // ==========================================================================
  // UI WIDGETS
  // ==========================================================================

  function analyticsEvent(query) {
    document.dispatchEvent(
      new CustomEvent('theme.algoliaSearch', {
        detail: {
          searchQuery: query,
          searchPageType: 'collection'
        }
      })
    );
  }

  var searchAsYouType = false;
  var debounceTimer;
  var debounceTimeout = 500;

  // Search input
  instant.search.addWidgets([
    searchBox({
      container: '.ais-search-box-container',
      autofocus: false,
      showReset: true,
      showSubmit: true,
      showLoadingIndicator: false,
      searchAsYouType: searchAsYouType,
      placeholder: themeSettings.collectionTitle
        ? 'Search within ' + themeSettings.collectionTitle + '...'
        : 'Search keywords or part numbers...',
      cssClasses: {
        form: 'algolia-search-form',
        input: 'algolia-search-form__input form__field form__field--text',
        submit: 'algolia-search-form__submit button button--secondary',
        reset: 'algolia-search-form__reset button',
        submitIcon: 'icon'
      },
      queryHook: function(query, search) {
        analyticsEvent(query);
        if (searchAsYouType) {
          return search(query);
        }
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          search(query);
        }, debounceTimeout);
      }
    }),
  ]);

  /**
   * Custom widget for collection search.
   *
   * Handles switching between standard and Algolia results based on query,
   * as well as layout mode based on theme's layout switcher..
   */
  instant.search.addWidgets([
    {
      render: function(opts) {
        var query = opts.helper.getQuery().query;
        var standardWrapper = document.getElementById('collection-ui-wrapper');
        var algoliaWrapper = document.getElementById('ais-collection-ui-wrapper');

        // When there's a query, show Algolia results, otherwise show standard results.
        if (query && query.length) {
          standardWrapper.setAttribute('hidden', '');
          algoliaWrapper.removeAttribute('hidden');
        }
        else {
          standardWrapper.removeAttribute('hidden');
          algoliaWrapper.setAttribute('hidden', '');
        }

        // Un-hide wrappers - they may have been hidden during initialization.
        standardWrapper.style.visibility = 'visible';
        algoliaWrapper.style.visibility = 'visible';
      },
      init: function(opts) {
        var standardWrapper = document.getElementById('collection-ui-wrapper');
        var algoliaWrapper = document.getElementById('ais-collection-ui-wrapper');

        // Here we apply clicks on one layout switcher to the other.
        function delegateLayoutToggleClick(target) {
          return function(event) {
            var element = event.target;
            if (element.classList.contains('collection__layout-button')) {
              var correspondingElement = target.querySelector('.collection__layout-button[data-layout-mode="' + element.getAttribute('data-layout-mode') + '"]');
              if (correspondingElement) {
                correspondingElement.click();
              }
            }
          }
        }
        algoliaWrapper.addEventListener('click', delegateLayoutToggleClick(standardWrapper));
        standardWrapper.addEventListener('click', delegateLayoutToggleClick(algoliaWrapper));
      }
    }
  ]);

  // Collection mobile filters toggle
  instant.search.addWidgets([
    {
      render: function(opts) {
        var tags = collectionTagsFromPage();

        var filterIcon =
          '<svg focusable="false" class="icon icon--filter" viewBox="0 0 19 20" role="presentation">' +
          '  <path d="M17.0288086 4.01391602L11 9v7.0072021l-4 2.008545V9L1.01306152 4.01391602V1H17.0288086z" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="square"></path>' +
          '</svg>';

        document.querySelector('.ais-mobile-refinements-toggle').innerHTML =
          '<button class="collection__toolbar-item collection__toolbar-item--filter hidden-lap-and-up" data-action="open-drawer" aria-haspopup="true" aria-expanded="false" aria-controls="mobile-collection-filters">' +
          '  <span class="collection__filter-icon ' + (tags.length > 0 ? 'collection__filter-icon--active' : '') + '">' + filterIcon + '</span>' +
          '  Filter ' + (tags.length > 0 ? '(' + tags.length + ')' : '') +
          '</button>';
      }
    }
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text: instant.templates.stats,
      },
    }),
  ]);

  // Stats (mobile)
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-mobile-container',
      templates: {
        text: instant.templates.stats,
      },
    }),
  ]);

  // Sort orders
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container',
        items: instant.sortOrders,
        cssClasses: {
          root: 'algolia-sort-by',
          select: 'algolia-sort-by__select',
        }
      }),
    ]);
  }

  // Hidden facets
  var list = instant.facets.hidden.map(function(facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function() {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function() {},
    },
  ]);

  // ==========================================================================
  // RESULTS
  // ==========================================================================

  // TODO: Support different quick buy / quick view modes here.
  var additionalListClasses = themeSettings.quickView && themeSettings.quickView !== 'disabled'
    ? 'product-list--with-quick-view'
    : 'product-list--no-quick-view';

  // Hits
  // https://www.algolia.com/doc/api-reference/widgets/hits/js/
  var standardHits = hits({
    container: '.ais-hits-container',
    templates: {
      empty: instant.templates.empty,
      item: instant.templates.product,
    },
    cssClasses: {
      list: ['product-list', 'product-list--collection', 'product-list--with-sidebar', additionalListClasses],
      item: ['product-item', 'product-item--vertical', '1/3--tablet-and-up 1/4--desk'],
    },
    transformItems: function(products) {
      return products.map(function(product) {
        return algolia.assign({}, product, {
          _distinct: instant.distinct,
          can_order:
            product.inventory_management !== 'shopify' ||
            product.inventory_policy === 'continue' ||
            product.inventory_quantity > 0,
          translations: algolia.translations,
          queryID: product.__queryID,
          productPosition: product.__position,
          index: instant.search.mainIndex.getIndexName(),
        });
      });
    },
  });

  var customPartsHits = {
    init: function() {
      this.container = document.querySelector('.ais-hits-container');
    },
    render: function(renderOptions) {
      var results = [];
      // console.log('RESULTS', renderOptions.results);
      renderOptions.results.hits.forEach(function(hit) {
        var metafields = hit.meta.info || {};
        var equivalent_part_numbers = metafields.equivalent_part_number || '';

        var part_numbers = partsFields.indexOf('equivalent_part_number') > -1
          ? equivalent_part_numbers.split(',')
          : [equivalent_part_numbers];

        part_numbers.forEach(function(equivalent_part_number) {
          var result = Object.assign({}, hit);
          result.product_title_formatted = hit.title;
          result.variant_title_formatted = hit.variant_title !== 'Default Title' ? hit.variant_title : '--';
          result.product_id = hit.id;
          result.variant_id = hit.objectID;
          result.variant_url = '/products/' + hit.handle + '?variant=' + hit.objectID;
          result.part_number = metafields.part_number;
          result.previous_part_number = metafields.previous_part_number;
          result.equivalent_part_number = equivalent_part_number;
          result.short_description = hit.meta.product && hit.meta.product.short_description ? hit.meta.product.short_description : '--';
          result.variant_available = true;
          unavailableTags.forEach(function(tag) {
            if (hit.tags.indexOf(tag) !== -1) {
              result.variant_available = false;
            }
          });
          // console.log('HIT', hit);
          // console.log('TAGS', hit.tags);
          results.push(result);
        });
      });
      // console.log('RESULTS', results);
      this.container.innerHTML = algolia.render(instant.templates.parts, {
        results: results,
        hasResults: results.length > 0,
        collectionHandle: collectionHandle,
        skuLabel: partsSkuLabel,
      });
    }
  }

  instant.search.addWidgets([
    isPartsCollection ? customPartsHits : standardHits
  ]);

  // Redirect to product on click
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var hit;
          do {
            if (el.matches('.ais-hit')) {
              hit = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!hit) {
            return;
          }
          var $this = hit;
          var productHandle = $this.dataset.handle;
          var variant_id = $this.dataset.variantId;
          var distinct = $this.dataset.distinct;

          // Construct the link we should redirect to
          var link = '';

          // If we're on a collection page and the handle is available
          // then prefix the product link with the collection handle
          if (collectionHandle) {
            link = '/collections/' + collectionHandle;
          }

          // Add the product handle to the link
          link = link + '/products/' + productHandle;

          // Add the variant ID details to redirect to a specific
          // variant ID if we are showing variants and not products
          if (distinct !== 'true') {
            link += '?variant=' + variant_id;
          }

          if (algolia.config.analytics_enabled) {
            var clickData = {
              index: hit.dataset.algoliaIndex,
              eventName: 'click',
              queryID: hit.dataset.algoliaQueryid,
              objectIDs: [hit.dataset.algoliaObjectid],
              positions: [Number(hit.dataset.algoliaPosition)],
            };

            // Send the click event
            aa.clickedObjectIDsAfterSearch(clickData);
            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
            // algolia.saveForConversionTracking(clickData);
          }
          window.location.href = link;
        });
      },
    },
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function(opts) {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function(facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);

  // Pagination
  // https://www.algolia.com/doc/api-reference/widgets/pagination/js/
  instant.search.addWidgets([
    pagination({
      container: '.ais-pagination-container',
      padding: 3,
      maxPages: 20,
      showFirst: false,
      showLast: false,
      cssClasses: {
        root: 'pagination__inner',
        list: 'pagination__nav',
        pageItem: 'pagination__nav-item',
        'previousPageItem': ['pagination__prev', 'link'],
        'nextPageItem': ['pagination__next', 'link'],
        'firstPageItem': ['pagination__prev', 'link'],
        'lastPageItem': ['pagination__next', 'link'],
        'selectedItem': 'is-active',
      },
      templates: {
        previous: "« Previous",
        next: "Next »",
      },
    }),
  ]);

  // ==========================================================================
  // RUN
  // ==========================================================================

  instant.search.start();

  /**
  * Render callback to set appropriate hit classes based on active layout mode.
  *
  * We use the theme's layout switcher instead of Algolia's. Each render will wipe
  * out the active classes, so we re-add them here based on selected layout.
  */
  instant.search.on('render', function() {
    var button = document.querySelector('.ais-layout-switcher .collection__layout-button.is-selected');
    var mode = button ? button.dataset.layoutMode : null;

    if (!button || !mode) return;

    var items = document.querySelectorAll('.ais-hits-container .product-list .product-item') || [];
    items.forEach(function(item) {
      if (mode === 'list') {
        item.className = 'product-item product-item--list';
      }
      else {
        item.className = 'product-item product-item--vertical 1/3--tablet-and-up 1/4--desk'
      }
    });
  });

  /**
   * Extracts tags part of the collection URL.
   *
   * Generates an ordered tag string so we can easily compare changes.
   */
  var tagsFromUrl = function() {
    var pathname = window.location.pathname.split('?')[0].split('#')[0];
    var tags = pathname.split('/')[3];
    return tags ? tags.split('+').sort().join('+') : null;
  }

  var currentTags = tagsFromUrl();

  /**
   * Handles filter changes by the theme.
   *
   * When collection filters are clicked, the theme updates the page via AJAX. However, it does
   * not give us a good way to react to those changes. It does fire a generic theme:loading:end
   * event after content has been updated. What we do here is listen for that event and,
   * if tags in the URL have changed, we reset the Algolia query and refresh.
   */
  document.addEventListener('theme:loading:end', function() {
    var tagsAfterUpdate = tagsFromUrl();
    if (tagsAfterUpdate !== currentTags) {
      currentTags = tagsAfterUpdate;

      var url = new URL(window.location.href);
      var queryParam = url.searchParams.get('q');

      // Strip the query parameter from the URL. It will be incorrect
      // because the theme will pull from the initial page URL.
      if (queryParam && queryParam.length > 0)  {
        url.searchParams.delete('q');
        window.history.replaceState(null, '', url.toString());
      }

      // Trigger search now that we have new tags.
      instant.search.helper.setQuery('').search();
    }
  });

})(window.algoliaShopify);
